import { useState } from "react";
import TeambookTextForm from "../../TeambookTextForm";
import { useTranslation } from "react-i18next";
import Api from "../../../../Api";
import { useTeambookFilter } from "../../../../stores/planner";
import TeambookDialog from "../../TeambookDialog";
import PropTypes from "prop-types";

const SaveFilterModal = ({ setSaveFilterModalOpen, filterPage }) => {
  const { t } = useTranslation();
  const [filterName, setFilterName] = useState("");

  const saveFilter = () => {
    if (filterName.length === 0) {
      alert(t("planning.empty_filter"));
    } else {
      Api.Users.create_saved_filter(
        filterName,
        filterPage,
        JSON.stringify(useTeambookFilter.getState().filterValues)
      ).then(() => {
        setSaveFilterModalOpen(false);
      });
    }
  };

  return (
    <TeambookDialog
      onClose={() => setSaveFilterModalOpen(false)}
      title={t("planning.save_filter")}
      open={true}
      withCloseButton
      content={
        <TeambookTextForm
          style={{ width: "100%" }}
          fieldName={t("planning.filter_name")}
          fieldValue={filterName}
          onChange={setFilterName}
        />
      }
      actionButtons={[
        {
          text: t("save"),
          onClick: saveFilter,
        },
      ]}
    />
  );
};

SaveFilterModal.propTypes = {
  setSaveFilterModalOpen: PropTypes.func.isRequired,
  filterPage: PropTypes.string.isRequired,
};

export default SaveFilterModal;
